import React, {useContext} from 'react'
import { UserContext } from "../../../context/UserContext";

function Topdiv() {

  const {name, lastLogin} = useContext(UserContext);

  return (
    <div>
      <div className="relative bg-gradient-to-r from-blue-500 to-blue-900 text-white rounded-t-2xl rounded-b-lg shadow-lg mb-8 p-12 flex justify-between items-center">
        {/* <!-- Welcome Text --> */}
        <div>
          <span className="text-base font-light text-white">Welcome back!</span>
          <h1 className="text-xl font-semibold">{name}</h1>
          <span className="text-base font-light text-white mt-1">Last Login From: {lastLogin}</span>
        </div>
  
        {/* <!-- Illustration --> */}
        {/* <div>
          <img src="https://via.placeholder.com/100" alt="Illustration" className="w-24"/>
        </div> */}
      </div>
    </div>
  )
}

export default Topdiv
